import { Briefcase, Target, Calendar } from 'lucide-react'
import { motion } from 'framer-motion'
import { Button } from '@/components/ui/Button'
import { ETAPA_LABELS, formatCloserLeadDate } from '@/components/CloserLeads/Modals/closerLeadDetailsUtils'
import type { CloserLead } from '@/types'

interface CloserLeadDetailsDealsTabProps {
  lead: CloserLead
  onConvertToDeal: (id: string) => void
}

export function CloserLeadDetailsDealsTab({ lead, onConvertToDeal }: CloserLeadDetailsDealsTabProps) {
  const deals = lead.deals || []

  return (
    <motion.div key='deals' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className='flex-1 overflow-y-auto'>
      {deals.length === 0 ? (
        <div className='glass-card flex flex-col items-center justify-center py-16 text-text-muted/30'>
          <Briefcase size={48} strokeWidth={1} />
          <p className='text-[10px] font-bold uppercase tracking-widest mt-4'>Nenhum Deal vinculado</p>
          <p className='text-[10px] text-text-muted/50 mt-1'>Converta este lead para criar um deal</p>
          {lead.exclusividade ? null : (
            <Button variant='primary' size='sm' icon={<Target size={14} />} className='mt-4' onClick={() => onConvertToDeal(lead.id)}>
              Converter em Deal
            </Button>
          )}
        </div>
      ) : (
        <div className='space-y-3'>
          {deals.map((deal) => (
            <div key={deal.id} className='glass-card p-4 space-y-3'>
              <div className='flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                  <div className='p-2 rounded-xl bg-accent/10 text-accent'>
                    <Briefcase size={16} />
                  </div>
                  <div>
                    <h4 className='text-sm font-bold text-text-primary'>{deal.nome}</h4>
                    <span className='text-[9px] text-text-muted font-bold uppercase tracking-wider'>
                      {ETAPA_LABELS[deal.etapa] || deal.etapa}
                    </span>
                  </div>
                </div>
                <span className='text-lg font-black text-accent'>
                  R$ {Number(deal.valor || 0).toLocaleString('pt-BR')}
                </span>
              </div>
              <div className='flex items-center gap-4 text-[10px] text-text-muted'>
                <span className='flex items-center gap-1'>
                  <Target size={10} /> {deal.probabilidade || 0}% probabilidade
                </span>
                <span className='flex items-center gap-1'>
                  <Calendar size={10} /> {formatCloserLeadDate(deal.createdAt)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  )
}
